import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import { RingCentralClient } from '../../../lib/ringcentral/ringCentral'
import { Button } from 'reactstrap'
import { updateAuthData } from '../redux/userActions'

// Registruje message-store SMS pretplatu za ovog korisnika (P2P prijem), obrise
// prethodnu na RC strani i sacuva novi id na backendu. Best-effort: neuspeh ovde
// ne sme da obori sam RC login.
const registerUserSmsSubscription = async (instance) => {
  try {
    const address = `${process.env.REACT_APP_BACKEND_URL}/api/v2/rc/sms`
    const newId = await instance.registerSmsSubscription({ address })
    if (!newId) return
    const { data } = await axios.post('/users/rc-sms-subscription', { subscriptionId: newId })
    if (data && data.previousId && data.previousId !== newId) {
      await instance.deleteSubscription(data.previousId)
    }
  } catch (e) {
    // ne prekidaj login zbog pretplate
  }
}

const LoginToRCRoute = () => {
  const [message, setMessage] = useState('Please wait for system to login!')
  const { search } = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const searchParams = new URLSearchParams(search)
  const code = searchParams.get('code')
  const state = searchParams.get('state')

  useEffect(() => {
    const getAuthData = async (code, instance) => {
      const authData = await instance.getToken(code)
      return authData
    }

    const loadData = async () => {
      if (code && state) {
        try {
          const { userId } = JSON.parse(state)

          const instance = new RingCentralClient(userId)
          const authData = await getAuthData(code, instance)

          if (!Object.keys(authData).length) {
            throw new Error('Authorization code expired')
          }
          await dispatch(updateAuthData(authData, userId))

          // Sada kad je platform_oauth ulogovan, registruj korisnikovu SMS pretplatu
          await registerUserSmsSubscription(instance)

          setMessage('Successfully logged in!')
        } catch (e) {
          setMessage(`Error: ${e.message}. Please contact dev support with the message screenshot, or try login again!`)
        }
      }
    }

    loadData()
  }, [])

  const onGoBackClick = () => {
    history.push('/')
  }

  return (
    <div
      style={{
        display: 'grid',
        placeItems: 'center',
        width: '100vw',
        height: '100vh',
      }}
    >
      <div className='d-flex flex-column align-items-center justify-content-center'>
        <p>{message}</p>
        <Button className='btn btn-sm gold-color-button mt-2 ml-2' onClick={onGoBackClick}>
          <i className='fas fa-arrow-left mr-2'></i> Go back to dashboard
        </Button>
      </div>
    </div>
  )
}

export { LoginToRCRoute }
